/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Irrigation_Pump_Confirm_State_DelayInputs */

const vi_irrigation_pump_confirm_state_delay = /** @type {(inputs: Irrigation_Pump_Confirm_State_DelayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trạng thái bơm chỉ đổi sau vài giây, khi thiết bị báo về.`)
};

/**

* @param {Irrigation_Pump_Confirm_State_DelayInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const irrigation_pump_confirm_state_delay = /** @type {((inputs?: Irrigation_Pump_Confirm_State_DelayInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Irrigation_Pump_Confirm_State_DelayInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_irrigation_pump_confirm_state_delay(inputs)
});